/*
 * Product page buy box.
 * The theme's <product-form> bails out of its own AJAX path when
 * FoxTheme.settings.cartType === 'page' (theme.js handleFormSubmit), letting the
 * native POST /cart/add redirect to the cart. This intercepts that form instead:
 * AJAX add, 1s loading state, toast, header count. No drawer, no redirect.
 */
(function () {
  if (window.__productAtcInit) return;
  window.__productAtcInit = true;

  var IDLE = 'Add To Cart';
  var LOADING = 'Adding to your cart...';
  var OK_MSG = 'That product has been added to your cart.';
  var ERR_MSG = "Sorry, we couldn't add this item to your cart.";
  var MIN_MS = 1000;

  function routeAdd() {
    var r = window.FoxTheme && FoxTheme.routes && FoxTheme.routes.cart_add_url;
    return (r || '/cart/add') + '.js';
  }
  function routeCart() {
    var r = window.FoxTheme && FoxTheme.routes && FoxTheme.routes.cart_url;
    return (r || '/cart') + '.js';
  }

  function refreshCartCount() {
    return fetch(routeCart(), { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (window.FoxTheme && FoxTheme.pubsub && FoxTheme.pubsub.PUB_SUB_EVENTS) {
          FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart: cart });
        } else {
          document.querySelectorAll('cart-count').forEach(function (el) {
            el.innerText = cart.item_count > 99 ? '99+' : cart.item_count;
            el.hidden = cart.item_count === 0;
          });
        }
      })
      .catch(function () {});
  }

  function toast(msg, type) {
    if (typeof window.showCartToast === 'function') window.showCartToast(msg, type);
  }

  /* ---- zero-padded quantity display (real input value is untouched) ---- */
  function syncPad(input) {
    // Product form only. The cart uses the same <quantity-input> markup, but the
    // overlay's CSS is scoped to .product-form, so outside it this span rendered
    // as an unstyled block sitting in the cart row.
    var wrap = input.closest('.product-form quantity-input');
    if (!wrap) return;
    var el = wrap.querySelector('.quantity__display');
    if (!el) {
      el = document.createElement('span');
      el.className = 'quantity__display';
      el.setAttribute('aria-hidden', 'true');
      wrap.appendChild(el);
    }
    var n = parseInt(input.value, 10);
    if (isNaN(n)) n = parseInt(input.min, 10) || 1;
    el.textContent = n < 10 ? '0' + n : String(n);
  }
  function initPads(root) {
    (root || document).querySelectorAll('.product-form quantity-input .quantity__input').forEach(function (i) {
      syncPad(i);
    });
  }
  document.addEventListener('input', function (e) {
    if (e.target.classList && e.target.classList.contains('quantity__input')) syncPad(e.target);
  });
  document.addEventListener('change', function (e) {
    if (e.target.classList && e.target.classList.contains('quantity__input')) syncPad(e.target);
  });
  document.addEventListener('click', function (e) {
    var b = e.target.closest('.quantity__button');
    if (!b) return;
    var qwrap = b.closest('.product-form quantity-input');
    if (!qwrap) return;
    var inp = qwrap.querySelector('.quantity__input');
    if (inp) setTimeout(function () { syncPad(inp); }, 30);
  });
  document.addEventListener('DOMContentLoaded', function () { initPads(); });
  initPads();
  // The section re-renders on variant change. A MutationObserver would loop
  // here (writing the span is itself a mutation), so re-sync on the theme's
  // own variant event plus a light settle timer instead.
  document.addEventListener('variant:change', function () { setTimeout(initPads, 60); });
  window.FoxTheme && FoxTheme.pubsub && FoxTheme.pubsub.subscribe &&
    FoxTheme.pubsub.subscribe('variant-change', function () { setTimeout(initPads, 60); });

  /* ------------------------------ add to cart ------------------------------ */
  function setLoading(btn, on) {
    var span = btn.querySelector('.btn__text');
    if (on) {
      btn.dataset.loading = 'true';
      btn.setAttribute('aria-disabled', 'true');
      btn.disabled = true;
      btn.classList.add('is-loading');
      if (span) span.innerHTML = '<span class="cart-atc__spinner" aria-hidden="true"></span>' + LOADING;
    } else {
      btn.dataset.loading = 'false';
      btn.removeAttribute('aria-disabled');
      btn.disabled = false;
      btn.classList.remove('is-loading');
      if (span) span.textContent = IDLE;
    }
  }

  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      if (!form.matches || !form.matches('form[action*="/cart/add"]')) return;
      // product page buy box only — card ATC has its own handler
      if (!form.closest('.product-form')) return;

      var btn = form.querySelector('[name="add"]');
      if (!btn) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      if (btn.dataset.loading === 'true') return; // no double submits

      var fd = new FormData(form);
      var id = fd.get('id');
      var qty = parseInt(fd.get('quantity'), 10) || 1;
      if (!id) return;

      // carry line-item properties and selling plan through
      var payload = { id: Number(id), quantity: qty };
      var props = {};
      fd.forEach(function (v, k) {
        var m = k.match(/^properties\[(.+)\]$/);
        if (m) props[m[1]] = v;
      });
      if (Object.keys(props).length) payload.properties = props;
      if (fd.get('selling_plan')) payload.selling_plan = Number(fd.get('selling_plan'));

      setLoading(btn, true);

      var request = fetch(routeAdd(), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [payload] }),
      })
        .then(function (res) {
          return res.json().then(function (data) {
            if (!res.ok || data.status || data.errors) {
              throw new Error(data.description || data.message || ERR_MSG);
            }
            return data;
          });
        })
        .then(function () { refreshCartCount(); return { ok: true }; })
        .catch(function (err) { return { ok: false, message: (err && err.message) || ERR_MSG }; });

      var hold = new Promise(function (r) { setTimeout(r, MIN_MS); });

      Promise.all([request, hold]).then(function (out) {
        setLoading(btn, false);
        if (out[0].ok) toast(OK_MSG, 'success');
        else toast(out[0].message || ERR_MSG, 'error');
      });
    },
    true // capture: run before the theme's own submit listener
  );
})();
